import styled from "@emotion/styled";
import { DESKTOP, lnbAndFloating } from "@/themes/device";
import {
  grayScale,
  mBody2,
  mCaption1,
  sparta,
  swc,
  wBody2,
} from "@teamsparta/design-system";

export const Background = styled.div<{
  isScrollUp: boolean;
  scrollTop: boolean;
  isSideMenuOpen: boolean;
}>`
  padding: 0 16px;
  position: fixed;
  height: 50px;
  width: 100%;
  display: ${({ isScrollUp, scrollTop }) =>
    scrollTop ? "initial" : isScrollUp ? "initial" : "none"};
  background: white;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  z-index: 501;
  ${DESKTOP} {
    padding: 0;
    height: 60px;
  }
`;

export const Wrapper = styled.div<{ scrollTop: boolean }>`
  display: flex;
  height: inherit;
  align-items: center;
  margin: 0 auto;
  ${mBody2};
  /* color: ${({ scrollTop }) =>
    scrollTop ? "white !important" : `${grayScale.gray90} !important`};*/
  color: ${grayScale.gray90} !important;
  justify-content: space-between;
  max-width: 328px;
  span {
    display: none;
    ${lnbAndFloating} {
      display: block;
    }
  }
  ${lnbAndFloating} {
    ${wBody2};
    max-width: 1440px;
    padding: 0 108px;
  }

  ${DESKTOP} {
    width: inherit;
    max-width: 1152px;
    padding: 0;
  }
`;

export const LeftItem = styled.div`
  display: flex;
  align-items: center;
`;

export const LnbItems = styled.div`
  display: none;
  white-space: nowrap;
  ${DESKTOP} {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
`;

export const LnbItem = styled.b<{ isClicked: boolean }>`
  ${wBody2};
  color: ${grayScale.gray90};
  font-weight: ${({ isClicked }) => (isClicked ? 700 : 400)};
  width: 100%;
  //min-width: 56px;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  &:hover {
    font-weight: 700;
  }

  ${DESKTOP} {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }
`;

export const AlimBadge = styled.small<{ isAlimStep: boolean }>`
  display: block;
  padding: 2px 8px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${mCaption1}
  font-size: 11px;
  color: ${({ isAlimStep }) => (isAlimStep ? grayScale.gray80 : swc.blue)};
  background-color: ${({ isAlimStep }) =>
    isAlimStep ? grayScale.gray10 : sparta.blue10};
  border-radius: 100px;
  margin-left: 10px;
`;

export const VerticalLine = styled.div`
  height: 16px;
  border-right: 1px solid ${grayScale.gray40};
`;
